import ListItemIcon from "@material-ui/core/ListItemIcon";
import {Typography} from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import React from "react";
import {NavLink} from "react-router-dom";
import {useDrawerListItemStyles} from "./DrawerListItemStyles";
import PropTypes from "prop-types";

const DrawerListItem = (props) => {
    const classes = useDrawerListItemStyles();
    return (
        <ListItem button
                  onClick={props.onClick}
                  className={classes.root}>
            <NavLink
                to={props.to}
                activeStyle={{backgroundColor: "#b14536"}}
                className={classes.listItemNavlink}>
                <ListItemIcon className={classes.listItemIcon}>
                    {props.icon}
                </ListItemIcon>
                <Typography variant={props.fontStyle} className={classes.listItemText}>
                    {props.text}
                </Typography>
            </NavLink>
        </ListItem>
    )
}

DrawerListItem.propTypes = {
    to: PropTypes.string.isRequired,
    icon: PropTypes.element.isRequired,
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func
}

DrawerListItem.defaultProps = {
    onClick: () => {
    }
}

export default DrawerListItem;
